var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserBoxLight1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User_box_light"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 45",
    d: "M19.4279 23.0285C19.1936 21.729 18.4003 20.5447 17.196 19.6964C15.9916 18.8481 14.4582 18.3936 12.8815 18.4176C11.3048 18.4415 9.79236 18.9423 8.62589 19.8266C7.45942 20.711 6.71852 21.9185 6.54121 23.2243",
    stroke: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 46",
    cx: 13,
    cy: 10.8333,
    rx: 3.25,
    ry: 3.25,
    stroke: "#F2F2F2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 26",
    x: 2.66663,
    y: 2.66666,
    width: 20.6667,
    height: 20.6667,
    rx: 3.5,
    stroke: "#F2F2F2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBoxLight1);
export default __webpack_public_path__ + "static/media/User_box_light (1).fc857e4e256aa64ce1f8a9e58f4ab59b.svg";
export { ForwardRef as ReactComponent };